import { initialState } from "./state"
import { withLogo } from "@/common/helpers/itemWithLogo.helper"

export const setEpisodes = (state, payload) => {
  state.episodes = payload === null ? null : payload.map(withLogo)
}

export const setEpisode = (state, payload) => {
  state.episode = withLogo(payload)
}

export const resetEpisode = (state) => {
  state.episode = initialState().episode
}

export const reset = (state) => {
  const s = initialState()
  Object.keys(s).forEach((key) => {
    state[key] = s[key]
  })
}
